import React from 'react';
import styled from 'styled-components';
import ColorPicker from './ColorPicker';

const PropertyField = ({ label, type, value, options, onChange, checked }) => {
  const renderField = () => {
    switch (type) {
      case 'text':
        return (
          <Input
            type="text"
            value={value}
            onChange={(e) => onChange(e.target.value)}
          />
        );
      case 'textarea':
        return (
          <Textarea
            value={value}
            onChange={(e) => onChange(e.target.value)}
          />
        );
      case 'select':
        return (
          <Select
            value={value}
            onChange={(e) => onChange(e.target.value)}
          >
            {options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Select>
        );
      case 'color':
        return (
          <ColorPicker
            color={value}
            onChange={onChange}
          />
        );
      case 'checkbox':
        return (
          <CheckboxContainer>
            <Checkbox
              type="checkbox"
              checked={checked}
              onChange={(e) => onChange(e.target.checked)}
            />
            <span>Enabled</span>
          </CheckboxContainer>
        );
      default:
        return null;
    }
  };

  return (
    <FieldContainer>
      <Label>{label}</Label>
      {renderField()}
    </FieldContainer>
  );
};

const FieldContainer = styled.div`
  margin-bottom: 15px;
`;

const Label = styled.label`
  display: block;
  font-size: 12px;
  font-weight: 500;
  color: #666;
  margin-bottom: 5px;
`;

const Input = styled.input`
  width: 100%;
  padding: 8px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  font-size: 14px;
  
  &:focus {
    outline: none;
    border-color: #5876ff;
  }
`;

const Textarea = styled.textarea`
  width: 100%;
  padding: 8px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  font-size: 14px;
  min-height: 80px;
  resize: vertical;
  
  &:focus {
    outline: none;
    border-color: #5876ff;
  }
`;

const Select = styled.select`
  width: 100%;
  padding: 8px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  font-size: 14px;
  background-color: #fff;
  
  &:focus {
    outline: none;
    border-color: #5876ff;
  }
`;

const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
`;

const Checkbox = styled.input`
  margin-right: 8px;
`;

export default PropertyField;
